<template>
    <label class="picker-toggle">
        <input type="checkbox" class="checkbox" :checked="value" @input="toggle">
        <div class="switch"></div>
        <span class="label" v-show="value">Hue</span>
		<span class="label" v-show="!value">Hsl</span>
    </label>
</template>

<script>
    export default {
        name: "PickerTypeToggle",
        props: {
            value: {},
        },

        methods: {
            toggle(event) {
                this.$emit('input', event.target.checked);
            }
        }

    }
</script>

<style lang="scss" scoped>
    .picker-toggle {
		display: inline-flex;
		align-items: center;
		cursor: pointer;

		.checkbox {
			display: none;
		}

		.switch {
			margin-right: 0.8rem;
		}

		.label {
			animation: fadein 300ms forwards;
		}

		@keyframes fadein {
			from { opacity: 0; }
			to   { opacity: 1; }
		}
    }

    .switch {
        position: relative;
		display: inline-flex;
		border-radius: 5px;
        width: 4rem;
		height: 2rem;
		background-color: #1f2020;
		padding: 4px;
		
		&::after {
			position: relative;
			left: 0%;
			transform: translateX(0%);

			border-radius: 3px;
			width: 1.6rem;
			background-color: #35C051;

			transition: left 300ms ease-in-out,
			            transform 300ms ease-in-out;

			content: '';
		}

		:checked + &::after {
			left: 100%;
			transform: translateX(-100%);
		}
    }
</style>